<template>
  <div>
    <SubHeader title="Cross Sell" />
    <validation-observer ref="observer" v-slot="{ handleSubmit }">
      <b-form ref="form" @submit.stop.prevent="handleSubmit(sendEmail)">

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="selectedBrand">Brand</label>
          </b-col>
          <b-col md="6">
            <validation-provider name="selectedBrand"
                                 :rules="{ required: true }"
                                 v-slot="validationContext">
              <b-form-select id="selectedBrand"
                             name="selectedBrand"
                             v-model="selectedbrand"
                             :options="brands"
                             :state="getValidationState(validationContext)"
                             value-field="id"
                             text-field="name"
                             @input="brandChanged()"></b-form-select>
            </validation-provider>
          </b-col>
        </b-row>
        <b-row class="my-1">
          <b-col md="3">
            <label for="notes">Message</label>
          </b-col>
          <b-col md="9">
            <validation-provider name="message"
                                 :rules="{ required: true }"
                                 v-slot="validationContext">

              <b-form-textarea id="message"
                               v-model="message"
                               rows="5"
                               :state="getValidationState(validationContext)"></b-form-textarea>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="selectedYourBrand">Your Brand</label>
          </b-col>
          <b-col md="6">
            <validation-provider name="selectedYourBrand"
                                 :rules="{ required: true }"
                                 v-slot="validationContext">
              <b-form-select id="selectedYourBrand"
                             name="selectedYourBrand"
                             v-model="selectedReferrerBrand"
                             :options="crossSellReferrerBrands"
                             :state="getValidationState(validationContext)"
                             value-field="id"
                             text-field="name"
                             ></b-form-select>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label :for="'clientAware'">Is the Client aware of the Referral?</label>
          </b-col>
          <b-col md="6">            
            <validation-provider name="clientAwareTrue"
                                 :rules="{ required: true }"
                                 v-slot="validationContext">
            <b-form-radio-group :id="'clientAware'" v-model="clientAware">
              
              <b-form-radio value="true" id="clientAwareTrue" :state="getValidationState(validationContext)">Yes</b-form-radio>
              <b-form-radio value="false">No</b-form-radio>
              <span v-if="validationContext.errors.length > 0" class="text-danger">Required</span>
            
            </b-form-radio-group>
          </validation-provider>
         
          </b-col>
        </b-row>

        <b-row class="my-1">
          <b-col md="3" class="label">
            <label for="vendor">Please select the correct contact for the Referral</label>
          </b-col>
          <b-col md="6">
            <validation-provider name="vendor"
                                 :rules="{ required: true }"
                                 v-slot="validationContext">
              <b-form-select id="vendor"
                             name="vendor"
                             v-model="selectedVendorId"
                             :options="vendors"
                             :state="getValidationState(validationContext)"
                             value-field="id"
                             text-field="name"
                             @input="changeVendor()"></b-form-select>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row v-if="selectedVendorId" class="my-1">
          <b-col md="3" class="label">
            <label for="vendor">Select correct Email</label>
          </b-col>
          <b-col md="6">
            <validation-provider name="vendorEmail"
                                 :rules="{ required: selectPhone == null ? true : false }"
                                 v-slot="validationContext">
              <b-form-select id="vendorEmail"
                             v-model="selectEmail"
                             :options="vendorEmails"
                             :state="getValidationState(validationContext)"
                             value-field="name"
                             text-field="name"></b-form-select>
                             <span class="text-primary">If the email is not listed and can be used by your brand then please add on the contact tab.</span>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row v-if="selectedVendorId" class="my-1">
          <b-col md="3" class="label">
            <label for="vendor">Please select the correct contact for the Referral</label>
          </b-col>
          <b-col md="6">
            <validation-provider name="vendorTelephone"
                                 :rules="{ required: selectEmail == null ? true : false }"
                                 v-slot="validationContext">
              <b-form-select id="vendorTelephone"
                             v-model="selectPhone"
                             :options="vendorTelephonenumbers"
                             :state="getValidationState(validationContext)"
                             value-field="name"
                             text-field="name"></b-form-select>
                             <span class="text-primary">If the phone is not listed and can be used by your brand then please add on the contact tab.</span>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row v-if="selectedVendorId" class="my-1">
          <b-col md="3">
            <label for="notes">Additional Contact Information</label>
          </b-col>
          <b-col md="9">
            <validation-provider name="additionalContactInformation"
                                 :rules="{ required: false }"
                                 v-slot="validationContext">

              <b-form-textarea id="additionalContactInformation"
                               v-model="additionalContactInformation"
                               rows="5"
                               :state="getValidationState(validationContext)"></b-form-textarea>
                               <span class="text-primary">This box is only to be used to provide contact information that can not be stored on globe.</span>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row  class="my-1">
          <b-col md="3">
          </b-col>
          <b-col md="9">
            <b-button type="submit" variant="success" class="margin-right">
              <font-awesome-icon icon="envelope" /> Send Email
            </b-button>
            <b-button type="submit" variant="warning" class="margin-right" @click="clear()">
              <font-awesome-icon icon="times" /> Clear
            </b-button>
          </b-col>
        </b-row>
        <div v-html="userMessageHTML" id="UserMessage"></div>
        <Feedback ref="sendEmail" />
      </b-form>
    </validation-observer>
    <CrossSellHistory :history="history"/>
  </div>
  
</template>


<script>
  import SubHeader from "@/components/shared/SubHeader.vue";
  import Feedback from "@/components/shared/Feedback.vue";
  import CompanyService from "../../../services/Company.service";
  import CrossSellHistory from "./CrossSellHistory.vue";

  export default {
    components: { SubHeader, Feedback, CrossSellHistory },
    props: {
      companyId: null,
      initialVendors: null,
      lookups: Object,
    },
    data() {
      return {
        message: null,
        selectedbrand: null,
        selectedVendorId: null,
        selectedReferrerBrand: null,
        selectEmail: null,
        selectPhone: null,
        additionalContactInformation: null,
        brands: null,
        userMessageHTML: null,
        crossSellReferrerBrands: null,        
        clientAware: null,
        vendors: null,        
        vendorEmails: [],
        vendorTelephonenumbers: [],
        history: null,
      }
    },
    methods: {
      sendEmail() {
        this.$http.post("/company/sendCrossSellEmail",
          {
            CompanyId: this.companyId,
            Message: this.message,
            BrandId: this.selectedbrand,
            CrossSellReferrerBrandId: this.selectedReferrerBrand,
            VendorId: this.selectedVendorId,
            ClientAware: this.clientAware,
            AdditionalContactInformation: this.additionalContactInformation,  
            EmailAddress: this.selectEmail, 
            PhoneNumber: this.selectPhone,
          }).then(result => {

            if (result.data === true) {
              this.$refs.sendEmail.showSuccess("Email Sent");
              this.getHistory();
              this.clear();
            }
          });
      },
      clear() {
        this.message = null;
        this.selectedbrand = null;
        this.selectedReferrerBrand = 5;
        this.selectedVendorId = null;
        this.clientAware = null;
        this.additionalContactInformation = null;
        this.selectEmail = null;
        this.selectPhone = null;
        setTimeout(() => {
          this.$refs.observer.reset();
        }, 0);     
      },
      brandChanged() {
        var brand = this.brands.filter(x => x.id == this.selectedbrand);
        if (brand.length > 0) {
          this.userMessageHTML = brand[0].userMessage;
        }
        else {
          this.userMessageHTML = null;
        }
      },
      getValidationState({ dirty, validated, valid = null }) {
        return dirty || validated ? valid : null;
      },
      changeVendor() {
        let vendor = this.initialVendors.filter(x => x.id == this.selectedVendorId)[0];
        if (vendor){
          this.vendorEmails = [];
          if (vendor.emailAddress){
            this.vendorEmails.push({name: vendor.emailAddress});
          }
          if (vendor.emailAddressAlternative){
            this.vendorEmails.push({name: vendor.emailAddressAlternative});
          }
          this.vendorTelephonenumbers = [];
          if (vendor.telephoneMobile){
            this.vendorTelephonenumbers.push({name: vendor.telephoneMobile});
          }
          if (vendor.telephoneBusiness){
            this.vendorTelephonenumbers.push({name: vendor.telephoneBusiness});
          }
          if (vendor.telephoneAlternative){
            this.vendorTelephonenumbers.push({name: vendor.telephoneAlternative});
          }
          console.log(this.vendorTelephonenumbers);
        }else{
          this.vendorEmails = null;
          this.vendorTelephonenumbers = null;
        }
      },
      getHistory(){
        CompanyService.getCompanyCrossSellHistory(this.companyId).then(results => {
          this.history = results.data;
        });
      }
    },
    watch: {
      lookups: function () {
        this.brands = this.lookups.crossSellBrands;
        this.crossSellReferrerBrands = this.lookups.crossSellReferrerBrands;
        this.selectedReferrerBrand = 5;
        this.getHistory();
      },
      initialVendors: function () {
        this.vendors = this.initialVendors.map(x => {
          if (x.fullname){
            return { id: x.id, name: x.fullname }
          }          
        });
      },
    }
  }
</script>
